import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import WarehouseInventoryContainer from 'app/containers/InventoryManagement/WarehouseInventory'

const WarehouseInventoryContainerPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.inventory_management)}</PageTitle>
      <WarehouseInventoryContainer />
    </>
  )
}
const WarehouseInventoryContainerPage = memo(
  WarehouseInventoryContainerPageCpn,
  isEqual,
)

export default WarehouseInventoryContainerPage
